"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientSystem = exports.TaxDivSystem = exports.AccountingSyncSource = exports.AccountingTypeSystem = exports.AccountingConfigKey = void 0;
exports.AccountingConfigKey = {
    ACCOUNTING_TYPE_SYSTEM: "AccountingTypeSystem",
    TAX_DIV_SYSTEM: "TaxDivSystem",
    ACCOUNTING_SYNC_SOURCE: "AccountingSyncSource",
};
exports.AccountingTypeSystem = {
    DEFAULT: "default",
    CONCUR: "concur",
    COUPA: "coupa",
    UNKNOWN: "unknown",
};
exports.AccountingSyncSource = {
    DEFAULT: "default",
    CONCUR: "concur",
};
exports.TaxDivSystem = {
    DEFAULT: "default",
    STATIC: "static",
    UNKNOWN: "unknown",
};
exports.RecipientSystem = {
    DEFAULT: "default",
    UNKNOWN: "unknown",
};
